"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTURE_WRAPPING = exports.TEXTURE_FILTERING = void 0;
// #endregion Interfaces (2)
// #region Enums (2)
var TEXTURE_FILTERING;
(function (TEXTURE_FILTERING) {
    TEXTURE_FILTERING[TEXTURE_FILTERING["NONE"] = 0] = "NONE";
    TEXTURE_FILTERING[TEXTURE_FILTERING["NEAREST"] = 9728] = "NEAREST";
    TEXTURE_FILTERING[TEXTURE_FILTERING["LINEAR"] = 9729] = "LINEAR";
    TEXTURE_FILTERING[TEXTURE_FILTERING["NEAREST_MIPMAP_NEAREST"] = 9984] = "NEAREST_MIPMAP_NEAREST";
    TEXTURE_FILTERING[TEXTURE_FILTERING["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
    TEXTURE_FILTERING[TEXTURE_FILTERING["NEAREST_MIPMAP_LINEAR"] = 9986] = "NEAREST_MIPMAP_LINEAR";
    TEXTURE_FILTERING[TEXTURE_FILTERING["LINEAR_MIPMAP_LINEAR"] = 9987] = "LINEAR_MIPMAP_LINEAR";
})(TEXTURE_FILTERING || (exports.TEXTURE_FILTERING = TEXTURE_FILTERING = {}));
var TEXTURE_WRAPPING;
(function (TEXTURE_WRAPPING) {
    TEXTURE_WRAPPING[TEXTURE_WRAPPING["REPEAT"] = 10497] = "REPEAT";
    TEXTURE_WRAPPING[TEXTURE_WRAPPING["CLAMP_TO_EDGE"] = 33071] = "CLAMP_TO_EDGE";
    TEXTURE_WRAPPING[TEXTURE_WRAPPING["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})(TEXTURE_WRAPPING || (exports.TEXTURE_WRAPPING = TEXTURE_WRAPPING = {}));
// #endregion Enums (2)
//# sourceMappingURL=IMapData.js.map